
import React from 'react';

import { debounce } from 'lodash';
import Moment from 'moment';
import queryString from 'query-string';

import HierarchicalReportLayout, { formatters } from 'components/hierarchical-report/Layout';

import integrationReportStore from '../../stores/integrationReport';

import { IntegrationReportProvider, useIntegrationReportStore } from './store'

export default class IntegrationReport extends HierarchicalReportLayout {
  store = integrationReportStore;
  title = 'Integration';

  useNewStore = () => {
    const store = useIntegrationReportStore()
    const { report: { useLoad } } = store
    useLoad()
    return store
  }

  componentDidMount() {
    const query = this.props.location.search && queryString.parse(this.props.location.search) || {};

    if (JSON.stringify(query) === "{}" || this.props.location.search.includes('configure')) return;

    if (query.startDate) {
      query.startDate = Moment(query.startDate, 'MM-DD-YYYY');
    }

    if (query.endDate) {
      query.endDate = Moment(query.endDate, 'MM-DD-YYYY');
    }

    if (query.filterby) {
      query.filterby = JSON.parse(query.filterby);
    }

    if (!Array.isArray(query.sortby)) query.sortby = [query.sortby];

    debounce(() => {
      this.setState({ startDate: query.startDate, endDate: query.endDate, groupby: query.groupby, metrics: query.metrics, sortby: query.sortby, filterby: query.filterby }, this.loadDataState);
    }, 300)()
  }

  configure = {
    filterby: {
      options: [
        {
          value: 'publisher',
          get label() {
            return <formatters.Loadable isLoading={integrationReportStore.publisher.isLoading}>Publisher</formatters.Loadable>
          },
          options: integrationReportStore.publisher.fetchData,
        },
        {
          value: 'allocation',
          get label() {
            return <formatters.Loadable isLoading={integrationReportStore.allocation.isLoading}>Allocation</formatters.Loadable>
          },
          options: integrationReportStore.allocation.fetchData,
        },
        {
          value: 'type',
          get label() {
            return <formatters.Loadable>Integration Type</formatters.Loadable>
          },
          options: async () => [
            { value: "register", label: "Register", getLabel: () => "Register", getValue: () => "register" },
            { value: "unsubscribe", label: "Unsubscribe", getLabel: () => "Unsubscribe", getValue: () => "unsubscribe" },
            { value: "delayed_register", label: "Delayed Register", getLabel: () => "Delayed Register", getValue: () => "delayed_register" },
            { value: "optout", label: "Optout", getLabel: () => "Optout", getValue: () => "optout" },
            { value: "contest_finish", label: "Contest Finish", getLabel: () => "Contest Finish", getValue: () => "contest_finish" },
            { value: "sweeps_confirmation", label: "Sweeps Confirmation", getLabel: () => "Sweeps Confirmation", getValue: () => "sweeps_confirmation" },
            { value: "sweeps_confirmation_ticket", label: "Sweeps Confirmation Ticket", getLabel: () => "Sweeps Confirmation Ticket", getValue: () => "sweeps_confirmation_ticket" },
            { value: "revenue_postback", label: "Revenue Postback", getLabel: () => "Revenue Postback", getValue: () => "revenue_postback" },
            { value: "revenue_poller", label: "Revenue Poller", getLabel: () => "Revenue Poller", getValue: () => "revenue_poller" },
            { value: "path_ping_post", label: "Path Ping/Post", getLabel: () => "Path Ping/Post", getValue: () => "path_ping_post" },
          ],
        },
        {
          value: 'registration_completed',
          get label() {
            return <formatters.Loadable>Registration Completed</formatters.Loadable>
          },
          options: async () => [
            { value: true, label: "Completed", getLabel: () => "Completed", getValue: () => true },
            { value: false, label: "Not Completed", getLabel: () => "Not Completed", getValue: () => false },
          ],
        },
        {
          value: 'registration_consent',
          get label() {
            return <formatters.Loadable>Registration Consent</formatters.Loadable>
          },
          options: async () => [
            { value: true, label: "Consent", getLabel: () => "Consent", getValue: () => true },
            { value: false, label: "Not Consent", getLabel: () => "Not Consent", getValue: () => false },
          ],
        },
        {
          value: 'vendor',
          get label() {
            return <formatters.Loadable>Vendor</formatters.Loadable>
          },
          options: async () => [
            { value: 'twyne', label: 'Twyne', getLabel: () => 'Twyne', getValue: () => 'twyne' },
            { value: 'twyne_direct_post', label: 'Twyne Direct Post', getLabel: () => 'Twyne Direct Post', getValue: () => 'twyne_direct_post' },
            { value: 'wishpond', label: 'Wishpond', getLabel: () => 'Wishpond', getValue: () => 'wishpond' },
            { value: 'aweber', label: 'Aweber', getLabel: () => 'Aweber', getValue: () => 'aweber' },
            { value: 'aib', label: 'AIB', getLabel: () => 'AIB', getValue: () => 'aib' },
            { value: 'sendlane', label: 'sendlane', getLabel: () => 'Sendlane', getValue: () => 'sendlane' },
            { value: 'http_get', label: 'HTTP GET', getLabel: () => 'HTTP GET', getValue: () => 'http_get' },
            { value: 'http_post', label: 'HTTP POST', getLabel: () => 'HTTP POST', getValue: () => 'http_post' },
            { value: 'twyne_optout', label: 'Twyne Optout', getLabel: () => 'Twyne Optout', getValue: () => 'twyne_optout' },
            { value: 'trusted_form', label: 'Trusted Form', getLabel: () => 'Trusted Form', getValue: () => 'trusted_form' },
            { value: 'sftp', label: 'SFTP', getLabel: () => 'SFTP', getValue: () => 'sftp' },
            { value: 'ftp', label: 'FTP', getLabel: () => 'FTP', getValue: () => 'ftp' },
            { value: 'trusted_form_extend', label: 'Trusted Form Extend', getLabel: () => 'Trusted Form Extend', getValue: () => 'trusted_form_extend' },
            { value: 'sca', label: 'SCA', getLabel: () => 'SCA', getValue: () => 'sca' },
            { value: 'midpath', label: 'Midpath', getLabel: () => 'Midpath', getValue: () => 'midpath' },
            { value: 'tcpa', label: 'TCPA', getLabel: () => 'TCPA', getValue: () => 'tcpa' },
            { value: 'registration', label: 'registration', getLabel: () => 'registration', getValue: () => 'registration' },
            { value: 'delayed_registration', label: 'Delayed Registration', getLabel: () => 'Delayed Registration', getValue: () => 'delayed_registration' },
            { value: 'email', label: 'Email', getLabel: () => 'Email', getValue: () => 'email' },
            { value: 'pushnotification', label: 'Push Notification', getLabel: () => 'Push Notification', getValue: () => 'pushnotification' },
            { value: 'retargeting', label: 'Retargeting', getLabel: () => 'Retargeting', getValue: () => 'retargeting' },
            { value: 'callcenter', label: 'Callcenter', getLabel: () => 'Callcenter', getValue: () => 'callcenter' },
            { value: 'twyne_registration', label: 'Twyne Registration', getLabel: () => 'Twyne Registration', getValue: () => 'twyne_registration' },
            { value: 'clickwall', label: 'Click Wall', getLabel: () => 'Click Wall', getValue: () => 'clickwall' },
            { value: 'exit', label: 'Exit', getLabel: () => 'Exit', getValue: () => 'exit' },
            { value: 'adsense', label: 'Adsense', getLabel: () => 'Adsense', getValue: () => 'adsense' },
            { value: 'cmspage', label: 'CMS page', getLabel: () => 'CMS page', getValue: () => 'cmspage' },
            { value: 'default', label: 'Default', getLabel: () => 'Default', getValue: () => 'default' },
          ],
        },
        {
          value: 'integration',
          get label() {
            return <formatters.Loadable isLoading={integrationReportStore.integration.isLoading}>Integration</formatters.Loadable>
          },
          options: integrationReportStore.integration.fetchData,
        },
      ],
    },
    groupby: {
      default: ['type', 'vendor'],
      options: [
        { value: 'integration', label: 'integration', group: 'Integration' },
        { value: 'type', label: 'type', group: 'Integration' },
        { value: 'vendor', label: 'vendor', group: 'Integration' },
        { value: 'trigger', label: 'Trigger', group: 'Integration' },
        { value: 'publisher', label: 'publisher', group: 'Traffic' },
        { value: 'allocation', label: 'allocation', group: 'Traffic' },
        { value: 'sid1', label: 'SubID 1', group: 'Traffic' },

        { value: 'hour', label: 'Delivery Hour', group: 'Date Intervals' },
        { value: 'day', label: 'Delivery Day', group: 'Date Intervals' },
        { value: 'month', label: 'Delivery Month', group: 'Date Intervals' },
        { value: 'year', label: 'Delivery Week', group: 'Date Intervals' },

        // { value: 'hour_unittime', label: 'Delivery Hour', group: 'Unit Time' },
        // { value: 'day_unittime', label: 'Delivery Day', group: 'Unit Time' },
        // { value: 'weekday_unittime', label: 'Delivery Weekday', group: 'Unit Time' },
        // { value: 'month_unittime', label: 'Delivery Month', group: 'Unit Time' },

        { value: 'day_session', label: 'Creation Day', group: 'Date Intervals' },
        { value: 'month_session', label: 'Creation Month', group: 'Date Intervals' },
        { value: 'week_session', label: 'Creation Week', group: 'Date Intervals' },
        { value: 'registration_consent', label: 'Registration Consent', group: 'Session' },
        { value: 'registration_completed', label: 'Registration Completed', group: 'Session' },
      ],
    },
    metrics: {
      default: ['medianLatency', 'successCalls', 'failedCalls', 'rulesSuccessful', 'uniqSession'],
      options: [
        { value: 'uniqSession', label: 'Unique Sessions', group: 'Default' },
        { value: 'rulesSuccessful', label: 'Rules accepted', group: 'Default' },
        { value: 'rulesSuccessfulPC', label: 'Rules accepted %', group: 'Ratio' },
        { value: 'prepingSuccessful', label: 'Preping accepted', group: 'Default' },
        { value: 'prepingSuccessfulPC', label: 'Preping accepted %', group: 'Ratio' },
        { value: 'prepingRejected', label: 'Preping rejected', group: 'Default' },
        { value: 'prepingRejectedPC', label: 'Preping rejected %', group: 'Ratio' },
        { value: 'successCalls', label: 'Success Calls', group: 'Default' },
        { value: 'successCallsPC', label: 'Success Calls %', group: 'Ratio' },
        { value: 'medianLatency', label: 'Median Latency ms', group: 'Default' },
        { value: 'failedCalls', label: 'Failed calls', group: 'Default' },
        { value: 'failedCallsPC', label: 'Failed Calls %', group: 'Ratio' },
      ],
    },
    sortby: {
      default: ['total desc'],
      options: [
        { value: 'total', label: 'Requests', group: 'Default' },
      ],
    },
  }

  metricColumns = [{
    dataField: 'uniqSession',
    customSort: false,
    text: "Unique Sessions",
    formatter: formatters.parentPercent(formatters.number, "uniqSession"),
  }, {
    dataField: 'rulesSuccessful',
    customSort: true,
    text: "Rules accepted",
    formatter: formatters.drilldown(this.newTab, 'rulesSuccessful'),
  }, {
    dataField: 'rulesSuccessfulPC',
    customSort: true,
    text: "Rules accepted (%)",
    formatter: cell => cell === 0 ? '--' : formatters.percent(cell),
  }, {
    dataField: 'prepingSuccessful',
    customSort: true,
    text: "Preping accepted",
    formatter: formatters.drilldown(this.newTab, 'prepingSuccessful'),
  }, {
    dataField: 'prepingSuccessfulPC',
    customSort: true,
    text: "Preping accepted (%)",
    formatter: cell => cell === 0 ? '--' : formatters.percent(cell),
  }, {
    dataField: 'prepingRejected',
    customSort: true,
    text: "Preping rejected",
    formatter: formatters.drilldown(this.newTab, 'prepingRejected'),
  }, {
    dataField: 'prepingRejectedPC',
    customSort: true,
    text: "Preping rejected (%)",
    formatter: cell => cell === 0 ? '--' : formatters.percent(cell),
  }, {
    dataField: 'successCalls',
    customSort: true,
    text: "Success",
    formatter: formatters.drilldown(this.newTab, 'successCalls'),
  }, {
    dataField: 'successCallsPC',
    customSort: true,
    text: "Success Calls (%)",
    formatter: cell => cell === 0 ? '--' : formatters.percent(cell),
  }, {
    dataField: 'medianLatency',
    customSort: true,
    text: "Median Latency (ms)",
    formatter: cell => !cell ? '--' : formatters.number(cell),
  }, {
    dataField: 'failedCalls',
    customSort: true,
    text: "Failed calls",
    formatter: formatters.drilldown(this.newTab, 'failedCalls'),
  }, {
    dataField: 'failedCallsPC',
    customSort: true,
    text: "Failed Calls (%)",
    formatter: cell => cell === 0 ? '--' : formatters.percent(cell),
  }]

  get columns() {
    const { metrics, groupby } = this.state || {}
    const metricColumns = this.metricColumns.filter(d => metrics && metrics.includes(d.dataField))
    return [{
      dataField: 'value',
      text: groupby && groupby.join(' / '),
      customSort: true,
      sortValue: row => row.name || row.keyString || row.value,
      formatter: formatters.name,
    }, {
      dataField: 'total',
      customSort: true,
      text: "Total Requests",
      sortValue: row => row.name || row.value,
      formatter: (cell, row) => cell === 0 ? '--' : formatters.drilldown(this.newTab, 'total')(cell, row),
    },
    ...metricColumns,
    ]
  }

  ReportProvider = ({ children }) => <IntegrationReportProvider>
    {children}
  </IntegrationReportProvider>
}
